export const NUMBER_OF_EMPLOYEES_OPTIONS = [
  { key: 'num-employees-1', text: '1 (solo)', value: '1' },
  { key: 'num-employees>1<6', text: '2-5 employees', value: '2-5' },
  { key: 'num-employees>6<11', text: '6-10', value: '6-10' },
  { key: 'num-employees>10', text: '10+', value: '10+' },
  { key: 'num-employees>25', text: '25+', value: '25+' },
  { key: 'num-employees>50', text: '50+', value: '50+' },
]

export const CUSTOMER_HELP_QUESTION_OPTIONS = [
  { key: 'customer-help-1', text: 'Nothing yet', value: 'Nothing yet' },
  { key: 'customer-help-2', text: 'Zendesk', value: 'Zendesk' },
  { key: 'customer-help-3', text: 'Help Scout', value: 'Help Scout' },
  { key: 'customer-help-4', text: 'Happy Fox', value: 'Happy Fox' },
  { key: 'customer-help-5', text: 'Freshdesk', value: 'Freshdesk' },
  { key: 'customer-help-6', text: 'Frontapp', value: 'Frontapp' },
  { key: 'customer-help-7', text: 'Intercom', value: 'Intercom' },
  { key: 'customer-help-8', text: 'Zoho Desk', value: 'Zoho Desk' },
  { key: 'customer-help-9', text: 'Live Agent', value: 'Live Agent' },
  { key: 'customer-help-10', text: 'Hiver', value: 'Hiver' },
  { key: 'customer-help-11', text: 'Gorgias', value: 'Gorgias' },
  { key: 'customer-help-12', text: 'Email', value: 'Email' },
  { key: 'customer-help-13', text: 'Desk.com (Salesforce)', value: 'Desk.com' },
  { key: 'customer-help-14', text: 'Other', value: 'Other' },
]

export const CUSTOMER_HELP_QUESTION_OPTIONS_V3 = [
  { key: 'customer-help-1', text: 'Nothing yet', value: 'Nothing yet' },
  { key: 'customer-help-12', text: 'Email', value: 'Email' },
  { key: 'customer-help-2', text: 'Zendesk', value: 'Zendesk' },
  { key: 'customer-help-14', text: 'Other', value: 'Other' },
]

export const INDUSTRY_OPTIONS = [
  { key: 'industry-1', text: 'E-commerce', value: 'E-commerce' },
  { key: 'industry-2', text: 'Software', value: 'Software' },
  { key: 'industry-3', text: 'Education', value: 'Education' },
  {
    key: 'industry-4',
    text: 'Media, Creative Industries',
    value: 'Media, Creative Industries',
  },
  {
    key: 'industry-5',
    text: 'Professional Services (Law, Consulting, etc.)',
    value: 'Professional Services',
  },
  {
    key: 'industry-6',
    text: 'Agriculture, Forestry, Mining',
    value: 'Agriculture, Forestry, Mining',
  },
  {
    key: 'industry-7',
    text: 'Industrials (Manufacturing, Construction, etc.)',
    value: 'Industrials',
  },
  {
    key: 'industry-8',
    text: 'Energy, Utilities',
    value: 'Energy, Utilities',
  },
  {
    key: 'industry-9',
    text: 'Transport, Logistics',
    value: 'Transport, Logistics',
  },
  {
    key: 'industry-10',
    text: 'Data Infrastructure, Telecom',
    value: 'Data Infrastructure, Telecom',
  },
  { key: 'industry-11', text: 'Healthcare', value: 'Healthcare' },
  {
    key: 'industry-12',
    text: 'Hospitality, Food, Leisure Travel',
    value: 'Hospitality, Food, Leisure Travel',
  },
  {
    key: 'industry-13',
    text: 'Public Services, Social Services',
    value: 'Public Services, Social Services',
  },
  {
    key: 'industry-14',
    text: 'Financial Services',
    value: 'Financial Services',
  },
  { key: 'industry-15', text: 'Retail', value: 'Retail' },
  { key: 'industry-16', text: 'Other', value: 'Other' },
]

export const ROLE_OPTIONS = [
  { key: 'owner-role-blank', text: null, value: null },
  { key: 'owner-role-1', text: 'CEO or founder', value: 'CEO or founder' },
  {
    key: 'owner-role-2',
    text: 'CS representative',
    value: 'CS representative',
  },
  {
    key: 'owner-role-3',
    text: 'CS manager or director',
    value: 'CS manager or director',
  },
  {
    key: 'owner-role-4',
    text: 'Marketing or sales dept.',
    value: 'Marketing or sales dept.',
  },
  { key: 'owner-role-5', text: 'Other', value: 'Other' },
]

export const HEAR_ABOUT_US_OPTIONS = [
  { key: 'hear-1', text: 'Search engine (ex Google)', value: 'Search engine' },
  {
    key: 'hear-2',
    text: 'Social media (Facebook, Youtube, etc.)',
    value: 'Social media',
  },
  { key: 'hear-3', text: 'Email', value: 'Email' },
  {
    key: 'hear-4',
    text: 'Software comparison site (ex. G2, Capterra)',
    value: 'Software comparison site',
  },
  { key: 'hear-5', text: 'Our blog', value: 'Our blog' },
  {
    key: 'hear-6',
    text: "Another company's blog post",
    value: "Another company's blog post",
  },
  { key: 'hear-7', text: 'Word of mouth', value: 'Word of mouth' },
  { key: 'hear-8', text: 'Other', value: 'Other' },
]

export const NUMBER_OF_EMPLOYEES_OPTIONS_V3 = [
  { key: 'num-users1', text: 'Just me', value: '1' },
  { key: 'num-users<5', text: 'Less than 5', value: 'less5' },
  { key: 'num-users<10', text: 'Less than 10', value: 'less10' },
  { key: 'num-users>=10', text: '10 or more', value: '10+' },
]

export const ROLE_OPTIONS_V3 = [
  { key: 'owner-role-1', text: 'Founder or CEO', value: 'CEO or founder' },
  {
    key: 'owner-role-3',
    text: 'Customer Support Manager',
    value: 'CS manager or director',
  },
  { key: 'owner-role-5', text: 'Other', value: 'Other' },
]

export const INDUSTRY_OPTIONS_V3 = [
  { key: 'industry-1', text: 'eCommerce', value: 'E-commerce' },
  { key: 'industry-2', text: 'SaaS', value: 'Software' },
  { key: 'industry-16', text: 'Other', value: 'Other' },
]

export const WHY_GROOVE_OPTIONS = [
  { text: 'Team shared inbox', value: 'email_support' },
  { text: 'Live Chat', value: 'chat' },
  { text: 'Social integrations', value: 'social_integrations' },
  { text: 'Knowledge base', value: 'kb' },
  { text: 'Rules & Automation', value: 'rules_and_automations' },
  { text: 'Self-service widget', value: 'widget' },
  { text: 'Reporting', value: 'reporting' },
  { text: 'Other', value: 'other' },
]

export const NUMBER_OF_EMPLOYEES_OPTIONS_V6 = [
  { key: 'num-users1', text: 'Only me', value: '1' },
  { key: 'num-users<4', text: `2-3 ${app.t('agents')}`, value: '2-3' },
  { key: 'num-users<=10', text: `4-10 ${app.t('agents')}`, value: '4-10' },
  { key: 'num-users>10', text: `11-50 ${app.t('agents')}`, value: '11-50' },
  { key: 'num-users>50', text: `50+ ${app.t('agents')}`, value: '50+' },
]

// NOTE (jscheel): These are just aliases to keep everything clean

export const CUSTOMER_HELP_QUESTION_OPTIONS_V4 = CUSTOMER_HELP_QUESTION_OPTIONS_V3
export const CUSTOMER_HELP_QUESTION_OPTIONS_V5 = CUSTOMER_HELP_QUESTION_OPTIONS_V3

export const NUMBER_OF_EMPLOYEES_OPTIONS_V4 = NUMBER_OF_EMPLOYEES_OPTIONS_V3
export const NUMBER_OF_EMPLOYEES_OPTIONS_V5 = NUMBER_OF_EMPLOYEES_OPTIONS_V3

export const ROLE_OPTIONS_V4 = ROLE_OPTIONS_V3
export const ROLE_OPTIONS_V5 = ROLE_OPTIONS_V3

export const INDUSTRY_OPTIONS_V4 = INDUSTRY_OPTIONS_V3
export const INDUSTRY_OPTIONS_V5 = INDUSTRY_OPTIONS_V3
